module.exports = __webpack_public_path__ + "img/soundAdd.20265bd1.svg";